import {
  Conversation,
  SendConversationTakeoverMessageDto,
  UpdateConversationTakeoverDataDto
} from 'shared/interfaces/Conversation';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const conversationTakeOverBaseEndpoint = '/conversation-takeover';

export const ConversationTakeoverService = {
  updateTakeoverData: async (
    updateConversationTakeoverDataDto: UpdateConversationTakeoverDataDto
  ): Promise<Conversation> => {
    const response = await axiosBaseInstance({
      method: 'put',
      url: `${conversationTakeOverBaseEndpoint}/update-takeover-data`,
      data: updateConversationTakeoverDataDto
    });

    return response.data;
  },

  sendTakeoverMessage: async (
    sendConversationTakeoverMessageDto: SendConversationTakeoverMessageDto
  ): Promise<Conversation> => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${conversationTakeOverBaseEndpoint}/send`,
      data: sendConversationTakeoverMessageDto
    });

    return response.data;
  },

  getConversationTakeoverById: async (conversationId: string): Promise<Conversation> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${conversationTakeOverBaseEndpoint}/${conversationId}`
    });

    return response.data;
  }
};
